import { render, staticRenderFns } from "./DedicatedFundList.vue?vue&type=template&id=21f47d83"
import script from "./DedicatedFundList.vue?vue&type=script&lang=js"
export * from "./DedicatedFundList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports